import {
    FileUploadDropZone,
    HelpTip,
    ListItem,
    Text,
    UnorderedList,
    InlineAlert,
    Code,
    Heading,
} from "@amzn/storm-ui";
import * as React from "react";
import styled from "styled-components";

import { uploadAcceptedFileTypes, uploadlargeFileWarning } from "./common";

export interface FileUploadProps {
    file?: File;
    displayName?: string;
    setFile: (file: File) => void;
}

const DescriptionList = styled(UnorderedList)`
    margin: 0;
    margin-inline-start: ${({ theme }) => theme.spacing.base.default};
`;

const DescriptionFileNameContainer = styled.div`
    max-width: 30vw;
`;

const DescriptionFileNameText = styled(Code)`
    overflow: hidden;
    text-overflow: ellipsis;
    text-align: center;
`;

export const FileUpload: React.FunctionComponent<FileUploadProps> = (
    props: FileUploadProps,
) => {
    const { file, setFile, displayName } = props;

    const heading = (
        <Heading renderAs="h5" color="default">
            Choose files or drag and drop
        </Heading>
    );

    const renderDescriptions = () => {
        return file || displayName ? (
            <DescriptionFileNameContainer>
                <DescriptionFileNameText renderAs="pre">
                    {file?.name ?? displayName}
                </DescriptionFileNameText>
                <InlineAlert
                    style={{ justifyContent: "center" }}
                    variant="warning"
                    message={
                        <Text renderAs="span">{uploadlargeFileWarning}</Text>
                    }
                />
            </DescriptionFileNameContainer>
        ) : (
            <DescriptionList>
                <ListItem>
                    <Text size="xsmall">
                        Supported File Types
                        <HelpTip position="right">
                            {uploadAcceptedFileTypes.map((fileType) => (
                                <Text size="xsmall">{fileType}</Text>
                            ))}
                        </HelpTip>
                    </Text>
                </ListItem>
                <ListItem>
                    <Text size="xsmall">5 GB or smaller</Text>
                </ListItem>
            </DescriptionList>
        );
    };

    return (
        <FileUploadDropZone
            data-testid="upload-pitched-content-file-upload"
            accept={uploadAcceptedFileTypes}
            dropzoneId="drop-zone"
            inputId="file-uploader"
            heading={heading}
            description={renderDescriptions()}
            onChange={(_e, files) => setFile(files[0])}
            fullWidth={false}
        />
    );
};
